/*
 * @Author: 秦少卫
 * @Date: 2024-07-13 08:35:12
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-07-28 18:31:56
 * @Description: file content
 */
/**
 * 判断当前页面是否在 iframe 中
 * @returns {boolean} 如果页面在 iframe 中，则返回 true，否则返回 false
 */

import dayjs from 'dayjs';
import { getBaseURL } from '@/api/strapiClass';

export function getParamFromURL(name: string) {
  // eslint-disable-next-line prefer-rest-params
  const u = arguments[1] || window.location.href,
    reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'),
    r = u.substr(u.indexOf('?') + 1).match(reg);
  return r != null ? decodeURI(r[2]) : '';
}

/**
 * 数组转树形结构
 * @param treeData
 * @param root
 * @returns
 */
export const formatTreeData = (treeData: any, root: any) => {
  const arr: any = [];
  treeData.forEach((item: any) => {
    if (item.pid * 1 === root) {
      const children = formatTreeData(treeData, item.id);
      item.children = children;
      item.value = item.id;
      item.title = item.name;
      arr.push(item);
    }
  });
  return arr;
};

export const formatTemplTreeData = (treeData: any, root: any) => {
  const arr: any = [];
  treeData.forEach((item: any) => {
    if (item.parentId * 1 === root) {
      const children = formatTemplTreeData(treeData, item.id);
      item.children = children;
      item.value = item.id;
      item.title = item.name;
      arr.push(item);
    }
  });
  return arr;
};

export const createFormData = (dataurl: string, filename = 'image.png') => {
  // 将 dataURL 转换为 File 对象
  const dataURLtoFile = (dataurl: string, filename: string) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1] || '';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const file = dataURLtoFile(dataurl, filename);
  const formData = new FormData();
  const time = new Date();
  formData.append('files', file, `${time.getTime()}`);
  return formData;
};

export const formatDate = (date: string) => {
  if (!date) return '-';
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};

//预览&获取图片
export const getImageUrl = (img: any, useHighRes = false) => {
  const baseUrl = getBaseURL();
  if (!img) return '';
  if (typeof img === 'string') {
    return img.startsWith('http') ? img : `${baseUrl}${img}`;
  }
  let imageUrl = '';
  if (useHighRes) {
    imageUrl = img.url || img.formats?.large?.url || img.formats?.medium?.url || '';
  } else {
    imageUrl = img.formats?.thumbnail?.url || img.formats?.small?.url || img.url || '';
  }

  if (!imageUrl) return '';
  return imageUrl.startsWith('http') ? imageUrl : `${baseUrl}${imageUrl}`;
};
